import { jsonMember, jsonObject } from 'typedjson';
import { PaymentMethodCode } from '../../../shared/enums/payment-method-code';
import { Guid } from '@web/utils';

@jsonObject
export class PublicOrderPaymentMethodResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly code!: PaymentMethodCode;

  @jsonMember(String)
  public readonly name!: string;
}
